import { ChangeDetectionStrategy, Component, computed, forwardRef } from '@angular/core';
import { NodeViewComponent } from '@examdojo/core/tiptap';
import { StopPropagationDirective } from '@examdojo/core/stop-propagation';
import { TiptapNodeViewContentDirective } from 'ngx-tiptap';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, RecipeBlock } from '../../../model';
import { DragWithHandleOnlyDirective } from '../drag-with-handle-only.directive';
import { DEFAULT_RECIPE_STEP_TITLE, RECIPE_STEP_NODE_NAME } from './recipe.model';

@Component({
  selector: 'dojo-recipe',
  standalone: true,
  imports: [TiptapNodeViewContentDirective, StopPropagationDirective],
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss'],
  hostDirectives: [DragWithHandleOnlyDirective],
  providers: [
    {
      provide: NodeViewComponent,
      useExisting: forwardRef(() => RecipeComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecipeComponent extends NodeViewComponent<RecipeBlock> {
  readonly isEditable = computed(() => this.editor().isEditable);
  readonly customCss = this.getProp('custom_css');
  readonly hasBackground = computed(() => this.getProp('has_background')() !== false);
  readonly recipeName = this.getProp('name');

  toggleBackground(): void {
    this.updateProp('has_background', !this.hasBackground());
  }

  onNameChange(event: Event): void {
    this.updateProp('name', (event.target as HTMLInputElement).value);
  }

  override getDefaults = (): RecipeBlock => ({
    id: uuid(),
    type: ContentBlockType.Recipe,
    steps: [],
  });

  addStep(): void {
    const editor = this.editor();
    const pos = this.getPos()();
    const node = this.node();

    const insertPos = pos + node.nodeSize - 1;
    editor
      .chain()
      .insertContentAt(insertPos, {
        type: RECIPE_STEP_NODE_NAME,
        attrs: { title: DEFAULT_RECIPE_STEP_TITLE },
        content: [{ type: 'paragraph' }],
      })
      .run();
  }
}
